const getQueryVariable = (stringParams: string, variable: string): string => {
  const vars = stringParams.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }

  return "";
};

export const parseAccessTokenFromUrl = (url: string) => {
  const params = url.split("#")[1] ?? null;
  if (!params) {
    return "";
  }

  return getQueryVariable(params, "access_token");
};

export const parseLanguageFromUrl = (url: string) => {
  const params = url.split("#")[1] ?? null;
  if (!params) {
    return "";
  }

  return getQueryVariable(params, "state");
};
